<template>
  <div ref="miele">
    <div ref="mieleContent" class="loadbeeTabContent"></div>
  </div>
</template>

<script setup>
import {onMounted, onUpdated, ref} from "vue";
import {getActiveLanguage} from "laravel-vue-i18n";

const props = defineProps({
  product: Object,
});
const miele = ref(null);
const mieleContent = ref(null);
const reMount = () => {
  mieleContent.value.dataset.loadbeeApikey = "EzYJ5WvPApvEGLyGZRZRxh3PJSrp8rPC";
  mieleContent.value.dataset.loadbeeGtin = props.product.barcode;
  mieleContent.value.dataset.loadbeeLocale =
      getActiveLanguage() === "et" ? "et_EE" : "ru_RU";
  let mieleScript = document.createElement("script");
  mieleScript.setAttribute("async", "async");
  mieleScript.setAttribute(
      "src",
      "https://cdn.loadbee.com/js/loadbee_integration.js",
  );
  miele.value.appendChild(mieleScript);
};
onUpdated(() => reMount());
onMounted(() => reMount());
</script>
